import { action, computed, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import moment from "moment";
import { FilterStore } from "../FilterStore";
import { ChannelInvitationEditStore } from "./ChannelInvitationEditStore";

export class ChannelInvitationsStore {
  filterStore: FilterStore;
  loading = false;
  edit: ChannelInvitationEditStore;

  filter: any = {
    status: "",
    page: 0,
    size: 20,
    period: [undefined, undefined],
  };

  data = {
    total: 0,
    items: [],
  };

  constructor() {
    makeAutoObservable(this, {
      pagination: computed,
    });
    this.filterStore = new FilterStore(this);
    this.edit = new ChannelInvitationEditStore(this);
  }

  get pagination() {
    return {
      current: this.filter.page + 1,
      pageSize: this.filter.size,
      total: this.data.total,
    };
  }

  @action onSearch(history) {
    this.onPage(history, 1, this.filter.size);
  }

  @action onPage(history, page, size) {
    let period: any[] = [undefined, undefined];
    if (this.filter.period?.[0]) {
      period = [
        moment(this.filter.period?.[0]).format("YYYY-MM-DD"),
        moment(this.filter.period?.[1]).format("YYYY-MM-DD"),
      ];
    }
    const query = new URLSearchParams({ ...this.filter, period, page: page - 1, size });
    history.push({ search: query.toString() });
  }

  @action onLocation(location) {
    const params = new URLSearchParams(location.search);
    console.log("query", params);
    const status = params.get("status") || "";

    const page = parseInt(params.get("page") || "0");
    const size = parseInt(params.get("size") || "20");

    const periodStr = params.get("period") || ",";
    const period = periodStr !== "," ? periodStr.split(",").map((x) => moment(x)) : [undefined, undefined];
    console.log("p", period);
    this.filter = { status, period, page, size };

    this.refresh();
  }

  @action
  refresh() {
    this.loading = true;
    const { period, page, size, status } = this.filter;
    const filter: any = { page, size, status };

    console.log("ss", period?.[0]);
    if (period?.[0]) {
      filter.period = [moment(period[0]).startOf("day").toISOString(), moment(period[1]).endOf("day").toISOString()];
    }
    return Api.invitation
      .channelInvitations(filter)
      .then((res) => {
        runInAction(() => {
          this.data = res.data.channelInvitations;
        });
      })
      .finally(() =>
        runInAction(() => {
          this.loading = false;
        })
      );
  }
}

export const channelInvitationsStore = new ChannelInvitationsStore();
